/*
 *  			'License for ONE AXA SOFTWARE - Inner Source'
 * 					L O A S - I S
 * 
 * The following License aims to be applied between the AXA Companies, according to the following definition:
 * "AXA Companies" means AXA, Société Anonyme with a “AXA Companies ” Board of Directors having its principal offices at 25, avenue Matignon, 75008 Paris, registered on the Commercial Registry of Paris under the number 572 093 920; and (i) any other company controlled by, or controlling AXA, with a company being considered as controlling another: (a) when it holds directly or indirectly a portion of the capital according to it the majority of the voting rights in general meetings of shareholders of this company; (b) when it holds solely the majority of the voting rights in this company by virtue of an agreement concluded with other partners or shareholders and which is not contrary to the interest of the company; (c) when it determines de facto, by voting rights which it holds, the decisions in the general meetings of shareholders of this company; (d) in any event, when it holds, directly or indirectly, a portion of voting rights greater than 40% and when no other partner or shareholder holds directly or indirectly a portion which is greater than its own; (ii) any economic interest group in which AXA and/or one or more other Companies of the AXA Group participates for at least 50% in operating costs; (iii) in the cases where the law applicable to a company limits voting rights or control (such as defined here in above), this company will be deemed to be a company of the AXA Group, if the voting rights in 2 Binding Corporate Rules – AXA Group – version 2013 general shareholders’ meetings or the control held by a Company of the AXA Group reaches the maximum amount fixed by said applicable law; and (iv) all AXA Companies constitute the “AXA Group” (hereafter "One AXA").  (Binding Corporate Rules - AXA Group - version 2019).
 * 
 * Software credits: 
 * 	Creator: AXA GO GETD
 * 	Main contributors: AXA GO GETD
 * 
 * Permission is hereby granted, free of charge, to any person or entity within One AXA obtaining a copy of this software and associated documentation files (the "Software"), to deal in the Software within One AXA, including the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions:
 * 
 * The above credit notice and this permission notice shall be included in all copies or substantial portions of the Software.
 * Any improvement or modification of the Software shall be made available to the whole One AXA, under the terms of this License.
 * 
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 */

import React from 'react';

const SvgIconNavManageBot = props => {
  return (
    <svg viewBox="0 0 30 30" {...props} role="img" aria-hidden="true" focusable="false">
      <g fill="none" fillRule="evenodd">
        <path fill="#FAFAFA" d="M-1842-203H537v1384h-2379z" />
        <path fill="#FFF" d="M-34-165h509v1308H-34z" />
        <g>
          <path
            fill="currentColor"
            d="M6.836 9.745c-.691 0-1.254-.71-1.254-1.58 0-.872.563-1.582 1.254-1.582.691 0 1.253.71 1.253 1.581 0 .872-.562 1.581-1.253 1.581m0-3.705c-.99 0-1.796.953-1.796 2.124 0 1.17.805 2.123 1.796 2.123.99 0 1.796-.952 1.796-2.123 0-1.17-.806-2.124-1.796-2.124"
          />
          <path
            stroke="currentColor"
            strokeWidth={0.88}
            vectorEffect="non-scaling-stroke"
            d="M6.836 9.745c-.691 0-1.254-.71-1.254-1.58 0-.872.563-1.582 1.254-1.582.691 0 1.253.71 1.253 1.581 0 .872-.562 1.581-1.253 1.581zm0-3.705c-.99 0-1.796.953-1.796 2.124 0 1.17.805 2.123 1.796 2.123.99 0 1.796-.952 1.796-2.123 0-1.17-.806-2.124-1.796-2.124z"
          />
          <path
            fill="currentColor"
            d="M11.23 10.287a.27.27 0 00.271-.27V6.311a.271.271 0 10-.542 0v3.704c0 .15.121.271.271.271"
          />
          <path
            stroke="currentColor"
            strokeWidth={0.88}
            vectorEffect="non-scaling-stroke"
            d="M11.23 10.287a.27.27 0 00.271-.27V6.311a.271.271 0 10-.542 0v3.704c0 .15.121.271.271.271z"
          />
          <path
            fill="currentColor"
            d="M14.1 6.04a.272.272 0 00-.272.271v3.705c0 .15.122.27.271.27a.27.27 0 00.272-.27V6.31a.271.271 0 00-.272-.271"
          />
          <path
            stroke="currentColor"
            strokeWidth={0.88}
            vectorEffect="non-scaling-stroke"
            d="M14.1 6.04a.272.272 0 00-.272.271v3.705c0 .15.122.27.271.27a.27.27 0 00.272-.27V6.31a.271.271 0 00-.272-.271z"
          />
          <path
            fill="currentColor"
            d="M16.97 6.04a.272.272 0 00-.272.271v3.705a.27.27 0 00.542 0V6.31a.27.27 0 00-.27-.271"
          />
          <path
            stroke="currentColor"
            strokeWidth={0.88}
            vectorEffect="non-scaling-stroke"
            d="M16.97 6.04a.272.272 0 00-.272.271v3.705a.27.27 0 00.542 0V6.31a.27.27 0 00-.27-.271z"
          />
          <path
            fill="currentColor"
            d="M21.364 6.582c.69 0 1.253.71 1.253 1.582 0 .871-.562 1.58-1.253 1.58-.692 0-1.254-.709-1.254-1.58 0-.872.562-1.582 1.254-1.582m0 3.705c.99 0 1.796-.952 1.796-2.122 0-1.172-.806-2.125-1.796-2.125-.991 0-1.797.952-1.797 2.124 0 1.17.807 2.122 1.797 2.122"
          />
          <path
            stroke="currentColor"
            strokeWidth={0.88}
            vectorEffect="non-scaling-stroke"
            d="M21.364 6.582c.69 0 1.253.71 1.253 1.582 0 .871-.562 1.58-1.253 1.58-.692 0-1.254-.709-1.254-1.58 0-.872.562-1.582 1.254-1.582zm0 3.705c.99 0 1.796-.952 1.796-2.122 0-1.172-.806-2.125-1.796-2.125-.991 0-1.797.952-1.797 2.124 0 1.17.807 2.122 1.797 2.122z"
          />
          <path
            fill="currentColor"
            d="M21.364 16.319c-.692 0-1.254-.71-1.254-1.581 0-.872.562-1.582 1.254-1.582.69 0 1.253.71 1.253 1.582 0 .871-.563 1.58-1.253 1.58m0-3.704c-.99 0-1.797.953-1.797 2.124 0 1.17.806 2.123 1.797 2.123.99 0 1.796-.952 1.796-2.123 0-1.171-.806-2.124-1.796-2.124"
          />
          <path
            stroke="currentColor"
            strokeWidth={0.88}
            vectorEffect="non-scaling-stroke"
            d="M21.364 16.319c-.692 0-1.254-.71-1.254-1.581 0-.872.562-1.582 1.254-1.582.69 0 1.253.71 1.253 1.582 0 .871-.563 1.58-1.253 1.58zm0-3.705c-.99 0-1.797.953-1.797 2.124 0 1.17.806 2.123 1.797 2.123.99 0 1.796-.952 1.796-2.123 0-1.171-.806-2.124-1.796-2.124z"
          />
          <path
            fill="currentColor"
            d="M16.97 12.614a.272.272 0 00-.272.271v3.705a.271.271 0 00.542 0v-3.705a.27.27 0 00-.27-.271"
          />
          <path
            stroke="currentColor"
            strokeWidth={0.88}
            vectorEffect="non-scaling-stroke"
            d="M16.97 12.614a.272.272 0 00-.272.271v3.705a.271.271 0 00.542 0v-3.705a.27.27 0 00-.27-.271z"
          />
          <path
            fill="currentColor"
            d="M12.575 16.319c-.691 0-1.254-.71-1.254-1.581 0-.872.562-1.582 1.254-1.582.691 0 1.254.71 1.254 1.582 0 .871-.563 1.58-1.254 1.58m0-3.704c-.99 0-1.796.953-1.796 2.124 0 1.17.806 2.123 1.796 2.123.991 0 1.796-.952 1.796-2.123 0-1.171-.806-2.124-1.796-2.124"
          />
          <path
            stroke="currentColor"
            strokeWidth={0.88}
            vectorEffect="non-scaling-stroke"
            d="M12.575 16.319c-.691 0-1.254-.71-1.254-1.581 0-.872.562-1.582 1.254-1.582.691 0 1.254.71 1.254 1.582 0 .871-.563 1.58-1.254 1.58zm0-3.705c-.99 0-1.796.953-1.796 2.124 0 1.17.806 2.123 1.796 2.123.991 0 1.796-.952 1.796-2.123 0-1.171-.806-2.124-1.796-2.124z"
          />
          <path
            fill="currentColor"
            d="M8.452 16.59v-3.705a.27.27 0 00-.271-.27.27.27 0 00-.272.27v3.705a.271.271 0 00.542.001"
          />
          <path
            stroke="currentColor"
            strokeWidth={0.88}
            vectorEffect="non-scaling-stroke"
            d="M8.452 16.59v-3.705a.27.27 0 00-.271-.27.27.27 0 00-.272.27v3.705a.271.271 0 00.542.001z"
          />
          <path
            fill="currentColor"
            d="M5.311 16.861a.27.27 0 00.271-.27v-3.707a.27.27 0 00-.542 0v3.705c0 .15.122.271.271.271"
          />
          <path
            stroke="currentColor"
            strokeWidth={0.88}
            vectorEffect="non-scaling-stroke"
            d="M5.311 16.861a.27.27 0 00.271-.27v-3.707a.27.27 0 00-.542 0v3.705c0 .15.122.271.271.271z"
          />
          <path
            fill="currentColor"
            d="M6.836 22.894c-.691 0-1.254-.71-1.254-1.582 0-.87.563-1.58 1.254-1.58.691 0 1.253.71 1.253 1.58 0 .872-.562 1.582-1.253 1.582m0-3.705c-.99 0-1.796.953-1.796 2.123 0 1.171.805 2.124 1.796 2.124.99 0 1.796-.953 1.796-2.124 0-1.17-.806-2.123-1.796-2.123"
          />
          <path
            stroke="currentColor"
            strokeWidth={0.88}
            vectorEffect="non-scaling-stroke"
            d="M6.836 22.894c-.691 0-1.254-.71-1.254-1.582 0-.87.563-1.58 1.254-1.58.691 0 1.253.71 1.253 1.58 0 .872-.562 1.582-1.253 1.582zm0-3.705c-.99 0-1.796.953-1.796 2.123 0 1.171.805 2.124 1.796 2.124.99 0 1.796-.953 1.796-2.124 0-1.17-.806-2.123-1.796-2.123z"
          />
          <path
            fill="currentColor"
            d="M11.23 19.189a.271.271 0 00-.271.271v3.705c0 .15.122.27.271.27a.27.27 0 00.271-.27V19.46a.27.27 0 00-.27-.271"
          />
          <path
            stroke="currentColor"
            strokeWidth={0.88}
            vectorEffect="non-scaling-stroke"
            d="M11.23 19.189a.271.271 0 00-.271.271v3.705c0 .15.122.27.271.27a.27.27 0 00.271-.27V19.46a.27.27 0 00-.27-.271z"
          />
          <path
            fill="currentColor"
            d="M14.1 19.189a.272.272 0 00-.272.271v3.705c0 .15.122.27.271.27a.27.27 0 00.272-.27V19.46a.271.271 0 00-.272-.271"
          />
          <path
            stroke="currentColor"
            strokeWidth={0.88}
            vectorEffect="non-scaling-stroke"
            d="M14.1 19.189a.272.272 0 00-.272.271v3.705c0 .15.122.27.271.27a.27.27 0 00.272-.27V19.46a.271.271 0 00-.272-.271z"
          />
          <path
            fill="currentColor"
            d="M16.97 19.189a.272.272 0 00-.272.271v3.705a.27.27 0 00.542 0V19.46a.27.27 0 00-.27-.271"
          />
          <path
            stroke="currentColor"
            strokeWidth={0.88}
            vectorEffect="non-scaling-stroke"
            d="M16.97 19.189a.272.272 0 00-.272.271v3.705a.27.27 0 00.542 0V19.46a.27.27 0 00-.27-.271z"
          />
          <path
            fill="currentColor"
            d="M21.364 22.894c-.692 0-1.254-.71-1.254-1.582 0-.87.562-1.58 1.254-1.58.69 0 1.253.71 1.253 1.58 0 .872-.563 1.582-1.253 1.582m0-3.705c-.99 0-1.797.953-1.797 2.123 0 1.171.806 2.124 1.797 2.124.99 0 1.796-.953 1.796-2.124 0-1.17-.806-2.123-1.796-2.123"
          />
          <path
            stroke="currentColor"
            strokeWidth={0.88}
            vectorEffect="non-scaling-stroke"
            d="M21.364 22.894c-.692 0-1.254-.71-1.254-1.582 0-.87.562-1.58 1.254-1.58.69 0 1.253.71 1.253 1.58 0 .872-.563 1.582-1.253 1.582zm0-3.705c-.99 0-1.797.953-1.797 2.123 0 1.171.806 2.124 1.797 2.124.99 0 1.796-.953 1.796-2.124 0-1.17-.806-2.123-1.796-2.123z"
          />
        </g>
      </g>
    </svg>
  );
};

export default SvgIconNavManageBot;
